import type { WrittenPage } from '../../sections'
import { LINKS } from '../links'

/**
 * Ahmet Bilgen'in iletişim sayfası.
 *
 * 15.09.2026'da istendi; adres talepte verildiği gibi
 * `/about/team/ahmet-bilgen`. Sayfa bir kartvizit: isim, unvan ve verilen üç
 * kanal — e-posta ile her ülke için bir numara. Biyografi uydurulmadı; üç
 * eş-CEO hakkında sitenin söyledikleri Hakkımızda'da kalıyor, sayfa da oraya
 * geri bağlanıyor.
 */
export const teamAhmetBilgen: WrittenPage = {
  navLabel: 'Ahmet Bilgen',
  title: 'Ahmet Bilgen: Eş-CEO, Teknoloji',
  description:
    'Digitopia Eş-CEO\'su Ahmet Bilgen ile iletişim: ahmet@digitopia.ai, +1 650 213 7440 (ABD) veya +90 532 307 85 95 (Türkiye).',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'Eş-CEO, Teknoloji',
      headline: 'Ahmet Bilgen',
      align: 'center',
      // 15.09.2026: fotoğraf yok — sayfaya zaten yüzünün olduğu bir kartvizitten
      // QR okutarak geliniyor, burası bir profil değil iletişim bilgisi.
      ctas: [
        { label: 'E-posta', href: 'mailto:ahmet@digitopia.ai' },
        { label: 'LinkedIn', href: 'https://www.linkedin.com/in/abilgen/' },
        // 17.09.2026: telefona doğrudan kaydetmek için vCard. Dosya
        // `public/vcf/` içinde, sayfanın slug'ıyla aynı adda.
        { label: 'Rehbere kaydet', href: '/vcf/ahmet-bilgen.vcf' },
      ],
    },
    {
      kind: 'features',
      heading: 'İletişim',
      columns: 3,
      items: [
        {
          title: 'ahmet@digitopia.ai',
          note: 'E-posta',
          href: 'mailto:ahmet@digitopia.ai',
        },
        {
          title: '+1 650 213 7440',
          note: 'ABD',
          href: 'tel:+16502137440',
        },
        {
          title: '+90 532 307 85 95',
          note: 'Türkiye',
          href: 'tel:+905323078595',
        },
      ],
      footnote: 'Digitopia New York, Londra ve İstanbul\'dan çalışıyor.',
    },
    {
      kind: 'cta',
      heading: 'Kişi yerine firmayla mı başlamak istersiniz?',
      sub: 'İletişim formu tüm ekibe ulaşır; Hakkımızda ise birlikte çalışacağınız diğer isimleri anlatır.',
      tone: 'band',
      ctas: [
        { label: 'Digitopia ile iletişime geçin', href: LINKS.contact },
        { label: 'Hakkımızda', href: LINKS.about },
      ],
    },
  ],
}
